// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ResetStorefrontSessionCookieModel, ResetStorefrontSessionModel } from "@store/Framework/Types/ApiModels";

const refreshSessionUrl = "api/v1/authenticationstatus/refresh-session";
const refreshCookieUrl = "api/v1/authenticationstatus/refresh-cookie";

export interface ResetStorefrontSessionCookieApiParameter extends ApiParameter {
    timestamp?: number;
}

export interface ResetStorefrontSessionApiParameter extends ApiParameter {
    timestamp?: number;
}

export const resetStorefrontCookie = (parameter: ResetStorefrontSessionCookieApiParameter) => {
    const apiParameter = { ...parameter, timestamp: Date.now() };
    return get<ResetStorefrontSessionCookieModel>(refreshCookieUrl, apiParameter);
};

export const resetStorefrontSession = (parameter: ResetStorefrontSessionApiParameter) => {
    const apiParameter = { ...parameter, timestamp: Date.now() };
    return get<ResetStorefrontSessionModel>(refreshSessionUrl, apiParameter);
};
